export default __webpack_public_path__ + "static/media/Engaging_result_02.bca6400e.png";